export default function EditorNote() {
  return (
    <section id="note" className="mt-16 md:mt-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          {/* portrait */}
          <div className="lg:col-span-5">
            <figure className="relative overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20middle%20aged%20newspaper%20columnist%20sitting%20at%20a%20desk%20lit%20by%20a%20single%20warm%20desk%20lamp%2C%20stack%20of%20printed%20gossip%20clippings%20and%20coffee%20cup%20nearby%2C%20moody%20vermillion%20and%20amber%20color%20grading%2C%20shallow%20depth%20of%20field%2C%20cinematic%20editorial%20documentary%20photography%2C%20warm%20intimate%20atmosphere&width=820&height=1040&seq=5gua-editor&orientation=portrait"
                alt="深夜伏案整理爆料素材的主编"
                title="5吃瓜网编辑部 · 主编手记配图"
                className="h-[360px] w-full object-cover md:h-[440px]"
              />
              <div className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-800">
                <i className="ri-edit-2-line text-sm w-4 h-4 flex items-center justify-center text-primary-600" />
                编辑部 · 主编手记
              </div>
            </figure>
          </div>

          {/* essay */}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <p className="text-[11px] tracking-[0.25em] text-primary-700 font-label">
              FROM THE DESK · 主编说
            </p>
            <h2 className="mt-3 font-serif text-3xl font-black leading-tight text-foreground-950 text-balance md:text-4xl">
              吃瓜容易，吃到
              <span className="text-accent-500">真瓜</span>难
            </h2>
            <blockquote className="mt-5 border-l-[3px] border-primary-500 pl-4 font-serif text-lg font-semibold leading-relaxed text-foreground-800">
              "我干了十几年娱乐口，最怕的不是没瓜，而是满屏都是半真半假的瓜。"
            </blockquote>
            <p className="mt-5 text-base leading-relaxed text-foreground-600">
              今晚这口瓜，画面是真的，但被什么风吹到热搜、又被谁在半路截了话题，才是真正值得扒的地方。
              我们不下场站队，只把时间线、原始画面和当事人前后口径摆到台面上——剩下的，交给瓜。
            </p>
            <p className="mt-3 text-base leading-relaxed text-foreground-600">
              5吃瓜网的原则很简单：爆料可以快，但每一口都要能溯源。独家讲清楚来源，实锤放得出证据，反转则老老实实认账。
            </p>
            <div className="mt-6 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 font-serif text-lg font-black text-background-50">
                  编
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">值班主编 · 老瓜</p>
                  <p className="text-xs text-foreground-400 font-label">2026年9月6日 22:00 落笔</p>
                </div>
              </div>
              <span className="hidden items-center gap-1.5 text-sm text-foreground-400 font-label sm:inline-flex">
                每晚一篇 · 说人话
                <i className="ri-quill-pen-line text-base w-4 h-4 flex items-center justify-center text-accent-500" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}